import { ISelectedFilter } from "@portal/components/pages/funds/filterOptions/types";
import { getFundFee } from "@portal/helpers/getFundFee";
import { IFund } from "@portal/types/api/IFund";
import { IPortfolioDepotFeeSettings } from "@portal/types/api/IPortfolioDepotFeeSettings";

export const filterFunds = (fundList: IFund[], filters: ISelectedFilter[], isinExcludeList?: string[]): IFund[] => {
  const filteredFunds = new Set<IFund>(fundList.filter(f => !isinExcludeList?.includes(f.isin)));
  filteredFunds.forEach(fund => {
    filters.forEach(filter => {
      if (filter.items.length === 0) return;
      const value = fund[filter.fieldId]?.toString();
      if (filter.search) {
        if (!value || !filter.items.find(fi => value.toLowerCase().includes(fi.value.toLowerCase()))) {
          filteredFunds.delete(fund);
        }
      } else if (!value || !filter.items.map(fi => fi.value).includes(value)) {
        filteredFunds.delete(fund);
      }
    });
  });
  return Array.from(filteredFunds);
};

export const mapFunds = (funds: IFund[], totalFundValue?: number, fundCosts?: IPortfolioDepotFeeSettings) =>
  funds.map(fund => {
    const fundFee = getFundFee(fund.custodyFeeType, totalFundValue ?? 0, fundCosts);
    const customerPrice = fund.nettoFeePercent + (fundFee ?? 0);
    return {
      ...fund,
      fundFee,
      customerPrice,
    };
  });

export const sortFunds = (funds: IFund[], field: keyof IFund, desc = false): IFund[] => {
  return funds.sort((a, b): number => {
    if (typeof a[field] === "string" || typeof b[field] === "string") {
      const columnA = a[field] as string;
      const columnB = b[field] as string;
      return desc ? columnB.localeCompare(columnA) : columnA.localeCompare(columnB);
    }

    if (typeof a[field] === "number" || typeof b[field] === "number") {
      if (typeof a[field] !== "number") {
        return desc ? 1 : -1;
      }
      if (typeof b[field] !== "number") {
        return desc ? -1 : 1;
      }
      const columnA = a[field] as number;
      const columnB = b[field] as number;
      return desc ? columnB - columnA : columnA - columnB;
    }

    if (typeof a[field] === "boolean" || typeof b[field] === "boolean") {
      return a[field] && desc ? 1 : a[field] ? -1 : 1;
    }

    return 0;
  });
};
